export default {_name:'Icon.Status',module:'Field',view:'Element/Icon/Status',options:{md:8}}